<template>
	<div style="height: 100%;">
		<page class="home-page" v-if="$route.path === '/home'" @scrollChange="scrollAnimation">
			<zui-header :headerActive="true"></zui-header>
			<!--获取首页banner栏下的文章列表，用来渲染banner-->
			<!--tag参数表示cms-article组件最终在页面上渲染出的元素-->
			<!--pid指得是这个文章列表的栏目id，栏目id在SystemColumnId文件中配置-->

			<!--首页banner-->
			<cms-article-list tag="div" :pid="$cid.home.banner" class="banner vivify fadeIn">
				<!--列表获取数据的方式类似与el-table的el-table-column，直接使用slot-scope的方式-->
				<template slot-scope="scope">
					<img :src="scope.list[bannerIndex].cover" alt="" class="bg_banner">
					<el-carousel class="carousel" :interval='7000' trigger="click" :autoplay="autoplay" ref="carousel" @change="changeBanner($event,scope.list)">
						<el-carousel-item v-for="item in scope.list" :key="item.id" style="cursor: pointer">
							<cms-image :class="isIE ? 'classie' : ''" :src="item.cover"
								@click="bannerClick(item)"></cms-image>

						</el-carousel-item>
					</el-carousel>
				</template>
			</cms-article-list>

			<!--直接获取首页下的所有栏目信息-->
			<div class="p-100">
				<!--系统公告-->
				<div class="notice-split"></div>
				<el-carousel direction="vertical" :autoplay="true" :interval="5000" indicator-position="none" arrow="never"
					class="notice">
					<el-carousel-item v-for="item in noticeList" :key="item.id">
						<div class="notice-item">
							<h1 class="br"><a target="_blank" :href="'/new/home/notice?id=' + item.id">{{ item.title }}</a>
							</h1>
							<div class="xiangxi ani-btn-arrow"><a target="_blank" href="/new/visitor/activity">更多公告 </a><em
									class="el-icon-right"></em></div>
						</div>
						<h3 class="vivify notice-intro">{{ item.intro }}</h3>
						<div class="xiangxi-mobile ani-btn-arrow"><a target="_blank" href="/new/visitor/activity">详细内容
							</a><em class="el-icon-right"></em></div>
					</el-carousel-item>
				</el-carousel>
				<div class="navdongtai">
					<!--景区·动态-->
					<div class="dongtai vivify fadeInTop delay-500">
						<div class="watermark blue">
							<div class="header-title">
								<div class="title">景区·动态</div>
								<div class="more"><a target="_blank" href="/new/visitor/activity?id=78">更多</a><img
										src="../assets/img/arrow.png" alt=""></div>
							</div>
							<cms-article-list :pid="$cid.home.jingQuDongTai" tag="ul" :limit="6"
								:parse-function="dongtaiListParse" unshift unshiftLimit class="sport">
								<template slot-scope="{ list }">
									<li class="li" v-for="(item,index) in list" :key="item.id" :class="acHoverItem === index ? 'ac_line' : ''">
										<div><a target="_blank" :href="'/new/visitor/activity/info?id=' + item.id">{{
											item.title }}</a></div>
										<!-- <div class="dt_time" v-html="item.timeEle"></div> -->
									</li>
									<li v-if="list.length === 0">
										<div>暂无动态内容</div>
										<div></div>
									</li>
								</template>
							</cms-article-list>
						</div>
						<cms-article-list tag="div" :pid="$cid.home.jingQuDongTai" :limit="6" class="right">
							<template slot-scope="{ list }">
								<div @mouseenter="hoverIn">
									<el-carousel class="carousel" @change="changeCarousel">
										<el-carousel-item v-for="item in list" :key="item.id" style="cursor: pointer">
											<cms-image :src="item.cover" @click="$openNewWindow('/new/visitor/activity/info?id=' + item.id)"></cms-image>
										</el-carousel-item>
									</el-carousel>
								</div>
							</template>
						</cms-article-list>
					</div>
					<!--便捷·服务-->
					<cms-column :id="$cid.home.bianJieFuWu" class="fuwu vivify fadeInBottom delay-800">
						<template slot-scope="{data}">
							<!--点击地图导览-->
							<div class="watermark blue">
								<div class="header-title">
									<div class="title">便捷·服务</div>
								</div>
								<div style="margin-bottom: 20px;" class="fuwu-note">{{ data.note }}</div>
								<cms-image :src="data.cover" class="map">
									<div class="mask" @click="showPicture(null, 1)">点击查看</div>
								</cms-image>
							</div>
							<div class="right" :class="isIE ? 'classie' : ''">
								<div class="bg1"></div>
								<div class="bg2"></div>
								<!--微信扫码、在线订票-->
								<cms-column-list :pid="$cid.home.bianJieFuWu" :limit="1" tag="div" class="bg3">
									<template slot-scope="{list}">
										<div class="ercode-box" v-if="list && list.length > 0">
											<el-popover
													placement="top"
													trigger="hover">
												<img :src="list[0].cover" alt="" style="width: 200px">
												<cms-image :src="list[0].cover" class="ercode" slot="reference"></cms-image>
											</el-popover>											<div class="ercode-content">
												<p class="title">{{ list[0].name }}</p>
												<p class="content">{{ list[0].note }}</p>
												<div class="er-btn">
													<a target="_blank" :href="'/new/visitor?preferential=1'">{{
														list[0].ext1value }}</a>
													<em class="el-icon-caret-right"></em>
												</div>
											</div>
										</div>
									</template>
								</cms-column-list>
								<!--运营时间-->
								<cms-article-list :pid="$cid.home.bianJieFuWu" :limit="3" tag="div" class="inner1_2-box">
									<template slot-scope="{list}">
										<div class="inner" v-for="item in list" :key="item.id">
											<p class="title">{{ item.title }}</p>
											<div v-html="item.content"></div>
										</div>
									</template>
								</cms-article-list>
							</div>
						</template>
					</cms-column>
				</div>
				<!--余票-->
				<div class="navdongtai">
					<!-- <div class="menpiao animate__animated animate__fadeInLeft animate__slower">
						<h3>峨眉山景区</h3>
						<h3>实时余票数据</h3>
						<h1>{{ ticketHtml[0].statDate.replace(/-/g, '/') }}</h1>
						<div class="piaoBg">
							<span>门票余量</span>
							<count-to :startVal='0' :endVal='ticketHtml[0].mpSurplusNum' :duration='3000'></count-to>
						</div>
						<div class="piaoBg" style="margin-bottom: 60px;">
							<span>高山区观光车票余量</span>
							<count-to :startVal='0' :endVal='ticketHtml[0].highCarSurplusNum' :duration='3000'></count-to>
						</div>
						<div class="see" @click="$openNewWindow('/new/visitor?tickets=1')">查看未来7日余票数据</div>
					</div> -->
					<!--经典线路-->
					<div class="xianlu animate__animated animate__fadeInRight animate__slower">
						<cms-article-list :pid="$cid.intro.jingDianXianLu" :limit="10" :parse-function="xinLuParse"
							:sort-by="1" class="nav clear">
							<template slot-scope="{ list }">
								<div v-for="(item, index) in list" :key="item.id"
									:style="{ backgroundImage: 'url(' + item._cover + ')' }" class="one vivify popIn"
									@mouseover="active = index" @mouseleave="active = 0"
									:class="{ active: active == index }">
									<logo :type="index + 1" width="103px" height="103px" class="logoT homexianlu"
										@click="$openNewWindow('/new/service/route/info?id=' + item.id)"></logo>
									<h3 @click="$openNewWindow('/new/service/route/info?id=' + item.id)">{{ item.title }}
									</h3>
									<div class="des" @click="$openNewWindow('/new/service/route/info?id=' + item.id)">
                  <div class="de_sp">线路:{{item.ext1}}</div>
                  <div>{{item.intro}}</div>
                  </div>
									<div class="flex"
										style="justify-content: space-around;margin-top: 70px;padding: 0 30px;">
										<a class="leftBtn" target="_blank"
											:href="'/new/service/route/info?id=' + item.id">详情</a>
										<a class="rightBtn" rel="noopener noreferrer" target="_blank" :href="item.ext2">购票</a>
									</div>
								</div>
							</template>
						</cms-article-list>
					</div>
				</div>
				<!--大美·峨眉-->
				<div class="navdongtai">
					<div class="damei vivify popInTop delay-800">
						<cms-column-list :pid="$cid.home.daMeiEMei" :limit="2" class="watermark blue"
							@loaded="daMeiEMeiLoaded">
							<template slot-scope="{ list }">
								<div class="header-title">
									<div class="title">大美·峨眉</div>
								</div>
								<div class="piaoBg" v-for="(item, index) in list" :key="item.id"
									:class="piaoBg === index ? 'active' : ''" @click="tab(index, list)">
									<div class="inner"> {{ item.name }}</div>
								</div>
							</template>
						</cms-column-list>
						<!--视频tab-->
						<cms-article-list pid="666" :ids="daMeiEMeiList[0].ext1value" :limit="4"
							v-if="piaoBg === 0 && daMeiEMeiList.length > 0" class="right vivify fadeIn">
							<template slot-scope="{ list }">
								<div class="flex">
									<div class="bg1" v-for="item in list" :key="item.id" @click="daMeiEMeiVideoClick(item)">
										<cms-image :src="item.cover" class="img" radius poster="video"
											animate="scale"></cms-image>
										<p class="emei-title">{{ item.title }}</p>
									</div>
								</div>
								<div class="more ani-btn-line blue-line" @click="$openNewWindow('/new/home/videos?id=666')">
									查看更多</div>
							</template>
						</cms-article-list>
						<!--图片tab-->
						<div class="right img-tab vivify fadeIn" v-show="piaoBg === 1">
							<!-- swiper1 -->
							<swiper v-if="isReady" class="swiper gallery-top dameiswiper" :options="swiperOptionTop" ref="swiperTop">
								<swiper-slide v-for="(item, index) in pictureList" :key="'picture1' + index"
									:style="'background-image:url(' + item.cover + ')'">
									<!-- <cms-image :src="item.cover" @click="showPicture(item.cover)"></cms-image> -->
                  <div class="picture-pop"  @click="showPicture(item.cover)">
                    <div class="picture-title" >{{ item.title }}
                  </div>
									</div>
								</swiper-slide>
							</swiper>
							<!-- swiper2 Thumbs -->
							<swiper v-if="isReady" class="swiper gallery-thumbs" :options="swiperOptionThumbs"
								ref="swiperThumbs">
								<swiper-slide v-for="(item, index) in pictureList" :key="'picture2' + index"
									:style="'background-image:url(' + item.cover + ')'">
									<!-- <cms-image :src="item.cover"></cms-image> -->
								</swiper-slide>
								<div class="swiper-button-next swiper-button-white" :style="isIE ? 'top: -0.18rem;' : ''"
									slot="button-next">
									<i class="el-icon-arrow-right ie-arrow ie-right" v-if="isIE"></i>
								</div>
								<div class="swiper-button-prev swiper-button-white" :style="isIE ? 'top: -0.18rem;' : ''"
									slot="button-prev">
									<i class="el-icon-arrow-left ie-arrow ie-left" v-if="isIE"></i>
								</div>
							</swiper>
							<div class="more ani-btn-line blue-line" @click="$openNewWindow('/new/link/pictureList')">
								查看更多</div>
						</div>
					</div>
					<!--精彩·体验-->
					<!-- <div class="tiyan vivify popInBottom delay-1500">
						<div class="watermark blue">
							<div class="header-title">
								<div class="title">精彩·体验</div>
								<div class="more">
									<a target="_blank" :href="'/new/plan/happy?id=' + activeName">更多</a><img
										src="../assets/img/arrow.png" alt=""></div>
							</div>
						</div>
						<cms-column-list :pid="$cid.play.wanDeAnYi" class="bottom">
							<template slot-scope="{ list }">
								<el-tabs v-model="activeName" @tab-click="handleClick" class="tab">
									<el-tab-pane v-for="(item, index) in list" :key="item.id" :label="item.name" :name="item.id" class="flex vivify fadeIn">
										<a class="d_f" :class="isIE ? 'classie' : ''" target="_blank" @click="$openNewWindow('/new/plan/happy?id=' + item.id);">
											<cms-image :src="item.cover" :lazy="false" class="contentImg"></cms-image>
											<div class="art" v-html="isIE ? (item.note.length > 190 ? (item.note.substring(0, 190) + '...') : item.note) : item.note"></div>
											<div class="more">
												<a target="_blank" @click="$openNewWindow('/new/plan/happy?id=' + item.id);">【详情】</a>
											</div>
										</a>
									</el-tab-pane>
								</el-tabs>
							</template>
						</cms-column-list>
					</div> -->

					<!--八部天龙-->
					<div class="eightGragon vivify popInBottom delay-1500"
						v-if="eightGragonData && eightGragonData.length > 0">
						<!--<div class="titel"></div>-->
						<div class="item" v-for="(item, index) in eightGragonLeft" :key="index + 'eightGragonLeft'"
							style="position:absolute" :style="{ top: item.top + '%', left: item.left + '%' }"
							@click="$openNewWindow('/new/eightGragon?index=' + item.id);">
							<cms-image :src="item.icon" :class="'icon1' + index" class="icon"></cms-image>
							<div class="name">{{ item.name }}</div>
						</div>
						<div class="item" v-for="(item, index) in eightGragonRight" :key="index + 'eightGragonRight'"
							style="position:absolute" :style="{ top: item.top + '%', right: item.left + '%' }"
							@click="$openNewWindow('/new/eightGragon?index=' + item.id);">
							<cms-image :src="item.icon" :class="'icon2' + index" class="eightGragon_icon"></cms-image>
							<div class="name">{{ item.name }}</div>
						</div>
						<div class="swiper_cl" >
							<swiper class="" :options="swiperOption_eightGragon" ref="swiperTop_eightGragon">
								<swiper-slide v-for="(item, index) in eightGragonData" :key="'slide' + index">
									<div class="eightGragon_image" @click="$openNewWindow('/new/eightGragon?index=' + index);">
										<img :src="item.imgs" class="eightGragon_image" radius>
									</div>
								</swiper-slide>
							</swiper>
						</div>
						<div class="eightGragon_pagination"></div>
						<div class="eightGragon_leftBtn"></div>
						<div class="eightGragon_rightBtn"></div>
					</div>

				</div>
				<!--攻略推荐-->
				<div class="gonglue">
					<div class="fo vivify fadeInBottom delay-1500"></div>
					<div class="title">攻略推荐</div>
					<!--<div>寻找适合您的旅游方式</div>--> <!--3.4文档修改去掉-->
					<div class="more ani-btn-line" @click="$openNewWindow('/new/service/strategy')">查看更多</div>
					<cms-article-list :pid="$cid.intro.daRenGongLue" :limit="10" class="gonglue-banner ">
						<template slot-scope="{ list }">

							<!-- swiper3 -->
							<swiper v-if="isReady" class="swiper gallery-top" :options="swiperOptionGl" ref="swiperTopGl" :info="JSON.stringify(list)">
								<swiper-slide v-for="(item, index) in list" :key="'picture1' + index">
									<div class="image-container top-img">
										<div class="tag" v-if="item.ext1">{{item.ext1}}</div>
										<img :src="item.cover" class="image scale" style="object-fit: cover;border-radius: 3px"/>
										<div class="image-title">{{ item.title }}</div>
									</div>
								</swiper-slide>
							</swiper>

							<div class="arrowLeft_out" :style="isIE ? 'top: -0.18rem;' : ''" slot="button-next">
								<div class="arrowLeft"></div>
							</div>
							<div class="arrowRight_out" :style="isIE ? 'top: -0.18rem;' : ''" slot="button-prev">
								<div class="arrowRight"></div>
							</div>
							<!--<div class="arrowLeft" @click="arrowClick('left')"></div>-->
							<!--<div class="arrowRight" @click="arrowClick('right')"></div>-->
							<!--	<CarouselFlexible :loop="true" :autoplay="true" arrow="never" :list="list"
											  carousel-class="el-carousel" carousel-item-class="el-car-item" image-class="top-img"
											  image-title-key="title" ref="cardShow" @item-click="methodItemClick" />-->
						</template>
					</cms-article-list>
				</div>
			</div>
			<zui-footer />
			<CmsVideoPlayer :src="videoSrc" :visible.sync="visible" :poster="poster" />

			<!--欢迎-->
			<!--<div class="welcom_pop_out" v-if="isShowWelcom">
				<img src="./img/welcom_pop_close.png" alt="" class="close" @click="closeWelcom">
				<img src="./img/welcom_pop.gif" alt="" class="welcom_pop">
			</div>-->
		</page>
		<router-view v-else></router-view>
	</div>
</template>
<script>
import './less/home-page.css'
import Logo from '../components/Logo'
import ZuiButton from '../components/Button'
import CarouselFlexible from "../components/CarouselFlexible.vue";
import CmsNoticeList from "~/components/cms/CmsNoticeList.vue";
import CmsVideoPlayer from "~/components/cms/CmsVideoPlayer.vue";
import countTo from 'vue-count-to';
import {
	getArticles
} from "~/api/CmsApi";
import {
	swiper,
	swiperSlide
} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import axios from 'axios';
import moment from "moment/moment";

export default {
	components: {
		Logo,
		ZuiButton,
		CarouselFlexible,
		CmsNoticeList,
		CmsVideoPlayer,
		swiper,
		swiperSlide,
		countTo
	},
	data() {
		return {
			bannerIndex:0,
			autoplay: true,
			scrollIndex: 0,
			videoSrc: '',
			visible: false,
			images: [require('~/views/img/bigMap.png')],
			poster: '',
			swiperOptionTop: {
				loop: true,
				loopedSlides: 4, // looped slides should be the same
				spaceBetween: 0,
				cache: false,

			},
			swiperOptionThumbs: {
				// autoplay:true,
				loop:true,
				loopedSlides: 3.5, // looped slides should be the same
				spaceBetween: 10,
				slidesPerView: 3.5,
				touchRatio: 0.2,
				slideToClickedSlide: true,
				// cache: false,
				centeredSlides: true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
				// cache: false
			},
			swiperOptionGl: {
				// autoplay: true,
				centeredSlides: true,
				loop: true,
				spaceBetween: 8,
				slidesPerView: 3,
				touchRatio: 0.2,
				slideToClickedSlide: true,
				navigation: {
					prevEl: '.arrowLeft_out',
					nextEl: '.arrowRight_out'
				},
				on:{
					click: () => {
						let swiperTopGl = this.$refs.swiperTopGl.swiper;
						let info = JSON.parse(swiperTopGl.$el[0].attributes.info.value);
						this.methodItemClick(info[swiperTopGl.realIndex])
					}
				}

				// cache: false
			},
			isReady: false,
			pictureIndex: 0,
			pictureList: [],
			piaoBg: 1,
			active: 0,
			activeName: '58',
			daMeiEMeiList: [],
			ticketHtml: [{
				highCarSurplusNum: 0,
				mpSurplusNum: 0,
				statDate: ''
			}],
			noticeList: [],
			isIE: false,
			xinLuParse: obj => {
				if (obj.ext1) {
					obj.activities = obj.ext1.split('-');
				} else {
					obj.activities = [];
				}
				if (obj.imgs) {
					obj._cover = obj.imgs.split(',')[0];
				} else {
					obj._cover = obj.cover;
				}
				return obj;
			},
			dongtaiListParse: item => {
				const md = moment(item.createTime).format('MM-DD');
				const [m, d] = md.split('-');
				item.timeEle = `<span>${m}</span><span>/${d}</span>`
				return item;
			},
			jingCaiTiYan: {
				id: '',
				cover: '',
				intro: ''
			},
			eightGragonData: [],
			eightGragonLeft: [
				{ icon: "", name: "", left: 8, top: 3 ,id:0},
				{ icon: "", name: "", left: 2, top: 20 ,id:1},
				{ icon: "", name: "", left: 8, top: 37 ,id:2},
				{ icon: "", name: "", left: 2, top: 54 ,id:3},
			],
			eightGragonRight: [
				{ icon: "", name: "", left: 8, top: 3 ,id:4},
				{ icon: "", name: "", left: 2, top: 20 ,id:5},
				{ icon: "", name: "", left: 8, top: 37 ,id:6},
				{ icon: "", name: "", left: 2, top: 54 ,id:7},
			],
			swiperOption_eightGragon: {
				autoplay: true,
				utoplay: {
					delay: 5000,
					stopOnLastSlide: false,
					disableOnInteraction: true,
				},
				loop: true,
				grabCursor:true,
				effect: "fade",
				touchMoveStopPropagation :true,
				edgeSwipeDetection:true,//禁止点击边缘左右翻页
				navigation: {
					prevEl: '.eightGragon_leftBtn',
					nextEl: '.eightGragon_rightBtn'
				},
				pagination: {
					el: '.eightGragon_pagination',
					clickable: true,
					//修改分页器样式
				},
				// cache: false
			},
			acHoverItem:-1,
			isShowWelcom:true,
		}
	},
	created() {
		this.isShowWelcom = sessionStorage.getItem('isShowWelcom') ? false : true;
		this.getNoticeList();
		this.loadGetTicket();
		if (document.documentMode)
			this.isIE = true;
	},
	mounted() {
		this.daMeiEmeiPictureLoaded();
		this.slideBanner();
		this.eightGragonDataList();
	},
	watch: {
		activeName: {
			handler(id) {
				this.jingCaiTiYan = {
					id: '',
					cover: '',
					intro: ''
				}
				getArticles({
					page: 1,
					limit: 1,
					cateId: id
				}).then(res => {
					const list = res.data.records || [];
					if (list && list.length > 0) {
						this.jingCaiTiYan = {
							id: list[0].id,
							cover: list[0].cover,
							intro: list[0].intro
						}
					}
				})
			},
			immediate: true,
		}
	},
	methods: {
		changeBanner(e,list){
			this.bannerIndex = e;
			console.log(e)
			console.log(list)
		},
		closeWelcom(){
			this.isShowWelcom = false;
			sessionStorage.setItem('isShowWelcom',1)
		},
		changeCarousel(active){
			this.acHoverItem = active;
		},
		hoverIn(e){
			let doms = e.target.children[0].children[0].children, _t = this;
			for(let i in doms){
				let classes = doms[i].classList;
				if(classes && classes.length){
					for(let k in classes){
						if('is-active' == classes[k]){
							_t.acHoverItem = i - 2
						}
					}
				}
			}
		},
		stopAuto() {
			this.autoplay = false
		},
		startAuto() {
			this.autoplay = true
		},
		// 轮播手滑切换
		slideBanner() {
			console.log(1)
			let that = this
			setTimeout(() => {
				//选中item的盒子
				var box = document.querySelector('.el-carousel__container')
				//手指起点X坐标
				var startPoint = 0
				//手指滑动重点X坐标
				var stopPoint = 0

				//重置坐标
				var resetPoint = function () {
					startPoint = 0
					stopPoint = 0
				}

				//手指按下
				box.addEventListener('touchstart', function (e) {
					//手指按下的时候停止自动轮播
					that.stopAuto()
					//手指点击位置的X坐标
					startPoint = e.changedTouches[0].pageX
				})
				//手指滑动
				box.addEventListener('touchmove', function (e) {
					//手指滑动后终点位置X的坐标
					stopPoint = e.changedTouches[0].pageX
				})
				//当手指抬起的时候，判断图片滚动离左右的距离
				box.addEventListener('touchend', function () {
					if (stopPoint == 0 || startPoint - stopPoint == 0) {
						resetPoint()
						that.startAuto()
						return
					}
					if (startPoint - stopPoint > 0) {
						resetPoint()
						that.$refs.carousel.next()
						that.startAuto()
						return
					}
					if (startPoint - stopPoint < 0) {
						resetPoint()
						that.$refs.carousel.prev()
						that.startAuto()
						return
					}
				})
			}, 2000)

		},
		bannerClick(item) {
			if (item.ext1) {
				window.open(item.ext1);
			}
		},
		scrollAnimation(e) {
			this.scrollIndex = e
		},
		getNoticeList() {
			getArticles({
				page: 1,
				limit: 3,
				cateId: this.$cid.home.jingQuGongGao,
				// ext2: '置顶文章'
			}).then(res => {
				this.noticeList = res.data.records || [];
			})
		},
		//点击查看大图
		showPicture(src, num) {
			this.$viewerApi({
				images: src ? [src] : this.images,
				options: {
					inline: false,
					button: true,
					navbar: false,
					title: false,
					toolbar: num ? true : false,
					tooltip: false,
					movable: num ? true : false,
					zoomable: num ? true : false,
					rotatable: false,
					scalable: num ? true : false,
					transition: false,
					fullscreen: true,
					keyboard: true,
				}
			})
		},
		loadGetTicket() {
			var that = this;
			// 2022.10.17 切换川大制胜数据接口
			axios.get(
				"https://www.zyou.cloud/bigdataapi/bigdata/api/emsticket/queryTicketAndHighTicketStatisc", {
				params: {}
			})
				.then(function (result) {
					var res = result.data
					if (res.code == 200) {
						let data = JSON.parse(JSON.stringify(res.results));
						that.TicketInfo = data.length ? JSON.parse(JSON.stringify(data[0])) : {};
						const ticketList = JSON.parse(JSON.stringify(data));
						// 如果余票数量小于0则设为0
						for (const ticketItem of ticketList) {
							if (ticketItem.highCarSurplusNum < 0) {
								ticketItem.highCarSurplusNum = 0;
							}
							if (ticketItem.mpSurplusNum < 0) {
								ticketItem.mpSurplusNum = 0;
							}
						}
						that.ticketHtml = ticketList;
						that.surplusTicket = data.length ? JSON.parse(JSON.stringify(data[0])) : [];
						//请求内部接口替换部分数据
						that.loadGetTicketUpdata()

					} else {
						console.warn('余票数据获取失败');
					}
				})
		},

		loadGetTicketUpdata() {
			var that = this;
			axios.get(
				"http://ypts.lintrondata.com/ypa/remainingTickets/listRemainingTickets?interval=6", {})
				.then(result => {
					var res = result.data
					if (res.code == 200) {
						let data = JSON.parse(JSON.stringify(res.data));
						for (let i of data) {
							for (let y = 0; y < that.ticketHtml.length; y++) {
								if (i.statDate == that.ticketHtml[y].statDate) {
									that.ticketHtml[y].statDate = i.statDate
									if (i.mpSurplusNum != 999999) {
										that.ticketHtml[y].mpSurplusNum = i.mpSurplusNum
									}
									if (i.highCarSurplusNum != 999999) {
										that.ticketHtml[y].highCarSurplusNum = i.highCarSurplusNum
									}
								}
								if (i == 0 && i.statDate == that.ticketHtml[y].statDate) {
									that.TicketInfo = i
									that.surplusTicket = i
								}
							}
						}
					} else {
						console.warn('余票数据获取失败');
					}
				})
			that.random_ticket();
		},
		random_ticket() {
			let _t = this;
			clearInterval(_t.interval);
			_t.interval = setInterval(function () {
				_t.loadGetTicket();
			}, 60000);
		},
		daMeiEmeiPictureLoaded() {
			var ivue = this
			getArticles({
				cateId: '888',
				page: 1,
				limit: 6
			}).then(res => {
				if (res.code === 0) {
					ivue.pictureList = res.data.records || [];
					ivue.isReady = true;
					ivue.$nextTick(() => {
						const swiperTop = ivue.$refs.swiperTop.swiper
						const swiperThumbs = ivue.$refs.swiperThumbs.swiper
						setTimeout(function () {
							swiperTop.controller.control = swiperThumbs
							swiperThumbs.controller.control = swiperTop
						}, 5000);
					})
				}
			})
		},
		daMeiEMeiVideoClick(item) {
			this.videoSrc = item.ext1;
			this.poster = item.cover;
			this.$nextTick(() => {
				this.visible = true;
			})
		},
		tab(index) {
			this.piaoBg = index;
		},
		daMeiEMeiLoaded(list) {
			this.daMeiEMeiList = list;
		},
		arrowClick(val) {
			if (val === 'right') {
				this.$refs.cardShow.next()
			} else {
				this.$refs.cardShow.prev()
			}
		},
		handleClick(tab, event) {
			console.log(this.activeName);
		},
		methodItemClick(item) {
			this.$openNewWindow('/new/service/strategy/info?id=' + item.id);
		},
		// 八部天龙数据
		eightGragonDataList() {
			var ivue = this
			getArticles({
				sortBy: 1,
				cateId: '1760593374942928898',
				page: 1,
				limit: 999
			}).then(res => {
				if (res.code === 0) {
					const list = res.data.records || [];
					// console.log(list)
					ivue.eightGragonData = ivue.deepClone(list)
					let leftData = list.slice(0, 4)
					let rightData = list.slice(4, 8)
					console.log(rightData)
					for (let i in leftData) {
						ivue.eightGragonLeft[i].icon = leftData[i].cover
						ivue.eightGragonLeft[i].name = leftData[i].title
					}
					for (let j in rightData) {
						ivue.eightGragonRight[j].icon = rightData[j].cover
						ivue.eightGragonRight[j].name = rightData[j].title
					}
				} else {
					console.warn('图片信息获取失败');
				}
			})
		},
		// 深拷贝
		deepClone(target) {
			// WeakMap作为记录对象Hash表（用于防止循环引用）
			const map = new WeakMap()
			// 判断是否为object类型的辅助函数，减少重复代码
			function isObject(target) {
				return (typeof target === 'object' && target) || typeof target === 'function'
			}
			function clone(data) {
				// 基础类型直接返回值
				if (!isObject(data)) {
					return data
				}

				// 日期或者正则对象则直接构造一个新的对象返回
				if ([Date, RegExp].includes(data.constructor)) {
					return new data.constructor(data)
				}

				// 处理函数对象
				if (typeof data === 'function') {
					return new Function('return ' + data.toString())()
				}

				// 如果该对象已存在，则直接返回该对象
				const exist = map.get(data)
				if (exist) {
					return exist
				}

				// 处理Map对象
				if (data instanceof Map) {
					const result = new Map()
					map.set(data, result)
					data.forEach((val, key) => {
						// 注意：map中的值为object的话也得深拷贝
						if (isObject(val)) {
							result.set(key, clone(val))
						} else {
							result.set(key, val)
						}
					})
					return result
				}

				// 处理Set对象
				if (data instanceof Set) {
					const result = new Set()
					map.set(data, result)
					data.forEach(val => {
						// 注意：set中的值为object的话也得深拷贝
						if (isObject(val)) {
							result.add(clone(val))
						} else {
							result.add(val)
						}
					})
					return result
				}

				// 收集键名（考虑了以Symbol作为key以及不可枚举的属性）
				const keys = Reflect.ownKeys(data)
				// 利用 Object 的 getOwnPropertyDescriptors 方法可以获得对象的所有属性以及对应的属性描述
				const allDesc = Object.getOwnPropertyDescriptors(data)
				// 结合 Object 的 create 方法创建一个新对象，并继承传入原对象的原型链， 这里得到的result是对data的浅拷贝
				const result = Object.create(Object.getPrototypeOf(data), allDesc)

				// 新对象加入到map中，进行记录
				map.set(data, result)

				// Object.create()是浅拷贝，所以要判断并递归执行深拷贝
				keys.forEach(key => {
					const val = data[key]
					if (isObject(val)) {
						// 属性值为 对象类型 或 函数对象 的话也需要进行深拷贝
						result[key] = clone(val)
					} else {
						result[key] = val
					}
				})
				return result
			}
			return clone(target)
		}

	}
}
</script>
<style scoped>
.ie-arrow {
	color: #ffffff;
	font-size: 0.155rem;
	position: absolute;
	top: 0.18rem;
	z-index: 1;
	width: 0.14rem;
	text-align: center;
	line-height: 0.36rem;
}

.ie-arrow.ie-left {
	left: 0px;
}

.ie-arrow.ie-right {
	right: 0px;
}
.homexianlu{
  margin: 0 auto;
}

</style>



// WEBPACK FOOTER //
// src/views/HomePage.vue